import { SupDepositRemove, SupPlusCircle } from "@repo/core-ui";
import React, { MouseEventHandler } from "react";
import { twMerge } from "tailwind-merge";

interface QuickDepositButtonProps {
  disabled?: boolean;
  className?: string;
  selected?: boolean;
  onAdd?: MouseEventHandler<HTMLButtonElement>;
  onRemove?: MouseEventHandler<HTMLButtonElement>;
}

export function QuickDepositButton({ disabled, className, onAdd, onRemove, selected }: QuickDepositButtonProps) {
  const handleClick = selected ? onRemove : onAdd;

  return (
    <button
      disabled={disabled}
      className={twMerge(
        "ml-auto h-10 border-0.5 border-primary-500 bg-primary-25 px-3 transition-colors duration-200 enabled:hover:bg-primary-75 enabled:[&:hover>svg>path]:fill-primary-500",
        disabled && "cursor-not-allowed bg-neutral-200 text-neutral-500",
        className
      )}
      onClick={handleClick}
    >
      {selected ? <SupDepositRemove width={16} height={16} /> : <SupPlusCircle width={16} height={16} />}
    </button>
  );
}
